<template>
    <div class="pz-save-to-workspace-folder-tree">
        <FolderTreeItem
            v-for="folder in folders"
            :key="folder.folder_id"
            :folder="folder"
            :level="0"
        />
    </div>
</template>

<script>
import FolderTreeItem from './FolderTreeItem';

export default {
    name: 'SaveToWorkspaceFolderTree',
    components: {
        FolderTreeItem,
    },
    inject: ['service'],
    props: {
        folders: {
            type: Array,
            required: true,
        },
    },
};
</script>
